export const connectOptionsByValue = (options, selectedOptions) => {
    if (!selectedOptions || selectedOptions.length === 0) {
        return [];
    }
    const optionByValue = new Map();
    for (const dropdownOption of options) {
        if (dropdownOption.type !== 'parent') {
            const value = dropdownOption.option.value;
            if (!optionByValue.has(value)) {
                optionByValue.set(value, dropdownOption);
            }
        }
    }
    return selectedOptions.map(selectedOption => { var _a; return (_a = optionByValue.get(selectedOption.value)) !== null && _a !== void 0 ? _a : { option: selectedOption }; });
};
export const findOptionIndex = (options, option) => {
    for (let index = 0; index < options.length; index++) {
        const __option = options[index];
        if (__option === option || __option.value === option.value) {
            return index;
        }
    }
    return -1;
};
//# sourceMappingURL=connect-options.js.map